import type { FindAllEventsResponseType } from 'src/api/generated/touring/types';
import {
  mapAnnouncementEventType,
  mapBirthdayEventType,
  mapFestivalEventType,
  mapShowEventType,
} from './helpers';
import type { FindAllEventsType } from './types';

export const mapFindAllEventsResponseType = (
  api: FindAllEventsResponseType
): FindAllEventsType => ({
  birthdays: api.data.birthdays.map(mapBirthdayEventType),
  shows: api.data.shows.map(mapShowEventType),
  festivals: api.data.festivals.map(mapFestivalEventType),
  announcements: api.data.announcements.map(mapAnnouncementEventType),
});
